document.addEventListener("DOMContentLoaded", function () {
    var faqBlocks = document.querySelectorAll(".schema-faq");

    faqBlocks.forEach(function (faqBlock) {
        var sections = faqBlock.querySelectorAll(".schema-faq-section");
        if (!sections.length) {
            return;
        }

        faqBlock.classList.add("faq-is-enhanced");

        sections.forEach(function (section, index) {
            var question = section.querySelector(".schema-faq-question");
            var answer = section.querySelector(".schema-faq-answer");

            if (!question || !answer) {
                return;
            }

            var answerId = section.id ? section.id + "-answer" : "faq-answer-" + index;
            answer.id = answerId;

            question.setAttribute("role", "button");
            question.setAttribute("tabindex", "0");
            question.setAttribute("aria-controls", answerId);

            var initiallyOpen = section.classList.contains("is-open");
            setSectionState(section, initiallyOpen);

            section.addEventListener("click", function (event) {
                if (event.target.closest(".schema-faq-answer")) {
                    event.preventDefault();
                    return;
                }

                toggleSection(section);
            });

            question.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggleSection(section);
                }
            });
        });
    });

    function toggleSection(targetSection) {
        var shouldOpen = !targetSection.classList.contains("is-open");
        setSectionState(targetSection, shouldOpen);
    }

    function setSectionState(section, isOpen) {
        var question = section.querySelector(".schema-faq-question");
        var answer = section.querySelector(".schema-faq-answer");

        if (!question || !answer) {
            return;
        }

        section.classList.toggle("is-open", isOpen);
        answer.hidden = !isOpen;
        question.setAttribute("aria-expanded", String(isOpen));
    }
});
